<template>
  <div class="container">
    <el-form ref="ruleForm" :model="formData" label-width="200px">
      <el-form-item label="机器人接待时间：">
        <div class="contBox1">
          <div style="color: red" v-if="timeStanza.length === 0">
            暂未设置时间段
          </div>
          <div style="color: red" v-else>下列时间段访客开口后首句自动取消托管</div>
          <div
            class="contBox1-list"
            v-for="(item, index) in timeStanza"
            :key="index"
          >
            <el-time-picker
              is-range
              :value="item.dataTime"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              size="mini"
              readonly
            >
            </el-time-picker>
            <el-button
              type="danger"
              size="mini"
              @click="deleteTime(item.id)"
              icon="el-icon-delete"
              circle
            ></el-button>
            <!-- <img
              src="../../../static/delete.png"
              @click="deleteTime(item.id)"
              alt=""
            /> -->
          </div>
          <el-button
            class="contBox1-add"
            type="primary"
            icon="el-icon-plus"
            size="medium"
            @click="
              () => {
                addTimeShow = !addTimeShow;
                dataTime = [new Date(), new Date(2023, 7, 5, 23, 59, 59)];
              }
            "
            >添加时间段</el-button
          >
          <!-- <div
            class="contBox1-add"
            @click="
              () => {
                addTimeShow = !addTimeShow;
                dataTime = [
                  new Date(),
                  new Date(new Date().getTime() + 1 * 3600 * 1000),
                ];
              }
            "
          >
            添加时间段
          </div> -->

          <div class="contBox1-temp" v-if="addTimeShow">
            <el-time-picker
              is-range
              v-model="dataTime"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              @change="changeTime"
            >
            </el-time-picker>
            <el-button
              type="success"
              size="mini"
              icon="el-icon-check"
              @click="addTime"
              circle
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="
                () => {
                  addTimeShow = false;
                  dataTime = [new Date(), new Date(2023, 7, 5, 23, 59, 59)];
                }
              "
              circle
            ></el-button>
            <!-- <img src="../../../static/tick.png" @click="addTime" alt="" />
            <img
              src="../../../static/delete.png"
              alt=""
              @click="
                () => {
                  addTimeShow = false;
                  dataTime = [
                    new Date(),
                    new Date(new Date().getTime() + 1 * 3600 * 1000),
                  ];
                }
              "
            /> -->
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // defaultTime: [new Date(), new Date()],
      timeStanza: [],
      dataTime: [new Date(), new Date(2023, 7, 5, 23, 59, 59)],
      formData: {},
      addTimeShow: false,
    };
  },
  mounted() {
    this.getTimeStanza();
  },

  methods: {
    // 获取时间段
    async getTimeStanza() {
      var api = "/manager/cancelReplySwitch/selectAll";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (res.resultCode == 10000) {
        this.timeStanza = [];
        console.log("时间段：", res);
        res.data.forEach((item) => {
          let start, end;
          if (!item.startTime) {
            start = [];
          } else {
            start = item.startTime.split(":");
          }
          if (!item.endTime) {
            end = [];
          } else {
            end = item.endTime.split(":");
          }
          console.log(start);
          console.log(end);
          this.timeStanza.push({
            dataTime: [
              new Date(2023, 6, 26, start[0], start[1], start[2]),
              new Date(2023, 6, 26, end[0], end[1], end[2]),
            ],
            id: item.id,
          });
        });
        console.log(this.timeStanza);
      } else {
        this.$message.error(res.desc);
      }
    },
    changeTime(time) {
      console.log(time);
    },

    // 保存接口
    async addTime() {
      this.$confirm("新增这段时间, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (!this.dataTime) {
            this.$message.warning("请输入时间");
            return;
          }
          const startTime = this.util.timeStampToDate(
            new Date(this.dataTime[0]).getTime(),
            4
          );
          const endTime = this.util.timeStampToDate(
            new Date(this.dataTime[1]).getTime(),
            4
          );
          var api = "/manager/cancelReplySwitch/edit";
          const res = await this.util.postRequest({
            url: api,
            method: "POST",
            data: {
              startTime,
              endTime,
              status: "on",
            },
          });
          if (res.resultCode == 10000) {
            this.dataTime = "";
            this.getTimeStanza();
          } else {
            this.$message.error(res.desc);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //   删除时间段
    deleteTime(id) {
      this.$confirm("删除这段时间, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var api = "/manager/cancelReplySwitch/del";
          const res = await this.util.postRequest({
            url: api,
            method: "POST",
            data: {
              id,
            },
          });
          if (res.resultCode == 10000) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getTimeStanza();
          } else {
            this.$message.error(res.desc);
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
  /deep/.contBox1 {
    display: flex;
    flex-direction: column;
    // background-color: #f6f7fa;
    .contBox1-list {
      display: flex;
      align-items: center;
      // img {
      //   width: 18px;
      //   height: 18px;
      //   cursor: pointer;
      //   margin-left: 8px;
      // }
      //   flex-direction: column;
      .el-button {
        margin-left: 10px;
      }
    }

    .contBox1-temp {
      display: flex;
      align-items: center;
      // img {
      //   width: 18px;
      //   height: 18px;
      //   cursor: pointer;
      //   margin-left: 8px;
      // }
      .el-button {
        margin-left: 10px;
      }
    }
    .contBox1-add {
      width: 104px;
      padding: 10px 6px;
      margin: 10px 0;
    }
    // .contBox1-add {
    //   color: blue;
    //   font-size: 16px;
    //   line-height: 1;
    //   margin: 10px 0;
    //   cursor: pointer;
    //   &::before {
    //     content: "+";
    //     display: inline-block;
    //     transform: scale(1.4); /* 定义缩放比例 */
    //     padding-bottom: 4px;
    //     margin-right: 4px;
    //   }
    // }
    .el-input__inner {
      width: 280px;
      margin-top: 6px;
    }
  }
}
/deep/.el-form {
  width: 600px;
  //   margin: 0 auto;
  .el-form-item {
    display: flex;
    // align-items: center;
    // justify-content: center;
    .el-form-item__content {
      display: flex;
      margin-left: 0 !important;
    }
    .el-form-item__label {
      padding: 0 12px 0 0;
    }
  }
}
/deep/ .el-input {
  width: auto;
  margin: 0 10px 0 0;
  .el-input__inner {
    width: 100px;
    height: 34px;
  }
}
</style>
